import type { ComponentType } from "react";

export interface SummaryCard {
  key: string;
  label: string;
  value: string;
  subtitle: string;
  icon: ComponentType<{ size: number; color?: string; className?: string }>;
  isCustomIcon?: boolean;
}

interface Props {
  cards: SummaryCard[];
}

export default function WarehouseSummaryCards({ cards }: Props) {
  return (
    <div className="grid grid-cols-2 gap-2 mb-4">
      {cards.map(function renderCard(card) {
        const Icon = card.icon;
        return (
          <div key={card.key} className="surface-container-fill radius-3xl p-5 flex flex-col gap-3">
            <div className="flex justify-start items-center gap-2">
              <div className="w-8 h-8 radius-xs surface-component-fill flex items-center justify-center content-action-neutral shrink-0">
                {card.isCustomIcon ? (
                  <Icon size={16} className="dark:text-white" />
                ) : (
                  <Icon size={16} color="currentColor" />
                )}
              </div>
              <p className="text-label-md content-base-primary">{card.label}</p>
            </div>
            <div className="flex flex-col gap-1">
              <p className="text-display-sm content-base-primary">{card.value}</p>
              <p className="text-body-regular-sm content-action-neutral">{card.subtitle}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
